import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import { MessageProvider } from "../../context/AppMessages";
import TripSearchResultSummaryView from "../../components/TripSearchResultSummaryView";
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { getIntlStringValue } from "../../helpers/StringHelpers";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import { InternationalStringDTO, MoneyDTO, TripDTO, TripResultDTO } from "../../apiclient/ApiDtos";
import SearchCriteria from "../../models/SearchCriteria";


interface Attrs {
    appContext: AppContext,
    searchCriteria: SearchCriteria,
    isSubmittingSeatReservation: boolean,
    tripResult: TripResultDTO,
    tripDetails: TripDTO | null,
    messageProvider: MessageProvider,
    errorMessage: InternationalStringDTO | null,
    onBackPressed: () => void,
    onConfirmSeatOrder: () => void
}


function SeatAssignmentAutoInfoPage(): m.Component<Attrs> {
    let isHidingSeatSelectionDetails: boolean = true;
    let isListeningScrollOnMain = false;

    return {
        view: function (vnode) {
            const { appContext, tripResult, tripDetails, onBackPressed } = vnode.attrs;
            let currLang = vnode.attrs.messageProvider.getCurrentLang();
            let notices: InternationalStringDTO[] = vnode.attrs.tripResult?.notices || [];

            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let totalSeatPriceCurrency = "MMK";
            let totalSelectedSeatsPriceAmount = 0;
            let totalSeatPrice: MoneyDTO = {
                amount: totalSelectedSeatsPriceAmount,
                currency: totalSeatPriceCurrency
            }

            let isMultipleSeatPricesTrip = tripDetails != null && tripDetails.priceRange.min.amount < tripDetails.priceRange.max.amount;
            return m("div.app-layout", [
                m(NavBar, {
                    title: vnode.attrs.appContext.getMessageProvider().get('nav_title.select_seat'),
                    canBackPress: true,
                    actionItems: langChangeActionItems,
                    onBackPressed: () => {
                        vnode.attrs.onBackPressed();
                    }
                }),

                m("div.app-area-below-nav",
                ),

                m("div.app-area-main",

                    [
                        m("div.card shadow-sm",
                            m("div.card-body p-3", [

                                m(TripSearchResultSummaryView, {
                                    tripResult: vnode.attrs.tripResult,
                                    numberOfSeats: vnode.attrs.searchCriteria.numberOfSeats,
                                    messageProvider: vnode.attrs.messageProvider,
                                    showingDate: true,
                                    showAsMultipleSeatPrice: true
                                }),

                                (notices.length > 0) ?
                                    m("div", { class: "alert alert-info mt-2 mb-0 p-2" },
                                        [
                                            m("small.font-weight-bold",
                                                vnode.attrs.appContext.getMessageProvider().get("trip.operator_notices", {
                                                    name: getIntlStringValue(tripResult.operator.name, currLang)
                                                })
                                            ),
                                            vnode.attrs.tripResult?.notices.map(notice => {
                                                return m("div", { class: "small" }, "- " + getIntlStringValue(notice, currLang))
                                            })
                                        ]
                                    )
                                    : null,
                            ])
                        ),

                        vnode.attrs.errorMessage != null ?

                            m("div.card card-body bg-white px-2 pb-0",
                                m("div", { class: "d-flex alert alert-warning p-2" },
                                    m(CustomSvgIcon, {
                                        iconType: 'exclamation_triangle',
                                        themeCssClass: 'svg-medium svg-warning-dark'
                                    }),
                                    m("small.ms-1 ml-1 font-weight-bold", currLang == "en" ? vnode.attrs.errorMessage.en : vnode.attrs.errorMessage.my)
                                )
                            )
                            :
                            null,


                        m("div.important-info-alert p-2 mt-2 small font-weight-bold",
                            vnode.attrs.messageProvider.get("small_car_details.seating_is_auto")
                        ),

                        m("div.d-flex font-weight-bold px-2 my-3 small",
                            m("div.text-muted", vnode.attrs.messageProvider.get("no_of_seats"), " -"),
                            m("div.ml-3 ", vnode.attrs.searchCriteria.numberOfSeats,
                                " ",
                                vnode.attrs.searchCriteria.numberOfSeats > 1 ?
                                    vnode.attrs.messageProvider.get("seats") :
                                    vnode.attrs.messageProvider.get("seat")

                            )
                        ),

                        m("div.card.mx-1",
                            m("div.card-body px-2 small border-top_ ",
                                m("div.font-weight-bold text-secondary",
                                    vnode.attrs.messageProvider.get("small_call_details.included_in_price")
                                ),
                                m("div.mt-3",
                                    m("div.d-flex",
                                        m(CustomSvgIcon, {
                                            iconType: 'check_circle',
                                            themeCssClass: "svg-small svg-success"
                                        }),
                                        m("div.ml-2", vnode.attrs.messageProvider.get("small_car_details.ride_far"))
                                    ),
                                    m("div.d-flex mt-1",
                                        m(CustomSvgIcon, {
                                            iconType: 'check_circle',
                                            themeCssClass: "svg-small svg-success"
                                        }),
                                        m("div.ml-2", vnode.attrs.messageProvider.get("small_car_details.standard_baggage_allowance"))
                                    )
                                )
                            ),
                            m("div.card-body px-2 border-top small ",


                                m("div.font-weight-bold text-secondary",
                                    vnode.attrs.messageProvider.get("small_call_details.not_included_in_price")
                                ),
                                m("div.mt-3",
                                    /* m("div.d-flex",
                                        m(CustomSvgIcon, {
                                            iconType: 'cross_remove_fill',
                                            themeCssClass: "svg-small svg-danger"
                                        }),
                                        m("div.ml-2", vnode.attrs.messageProvider.get("small_car_details.pick_up_service"))
                                    ), */
                                    m("div.d-flex mt-1",
                                        m(CustomSvgIcon, {
                                            iconType: 'cross_remove_fill',
                                            themeCssClass: "svg-small svg-danger"
                                        }),
                                        m("div.ml-2", vnode.attrs.messageProvider.get("small_car_details.pick_up_service_fee"))
                                    )
                                )
                            )
                        ),

                        tripDetails?.hasDropOffService || tripDetails?.hasPickUpService ?
                            null
                            :
                            m("div.alert alert-info small p-2 mx-1 mt-3", {
                                style: "line-height: 1.8rem !important;"
                            },
                                vnode.attrs.messageProvider.get("common.pickup_dropoff_info_details"),
                                /* vnode.attrs.messageProvider.get("common.pickup_dropoff_extra_fees_notice1"),
                                m("div.mt-2 font-weight-bold_", vnode.attrs.messageProvider.get("common.pickup_dropoff_extra_fees_notice2")) */
                            )
                    ]
                ),
                m("div.app-area-footer", [
                    m("div", { class: "card card-elevated-1" },


                        m("div.card-body px-3 py-2", [

                            m("div", [
                                m("div", { class: "text-right" },
                                    vnode.attrs.isSubmittingSeatReservation ?
                                        m("button", {
                                            class: "btn disabled btn-primary text-nowrap form-control"
                                        },
                                            appContext.getMessageProvider().get("seat_selection.submitting")
                                        ) :
                                        m("button", {
                                            class: "btn btn-primary text-nowrap form-control",
                                            disabled: false,
                                            onclick: (event) => {
                                                event.preventDefault();
                                                vnode.attrs.onConfirmSeatOrder()
                                            }
                                        },
                                            appContext.getMessageProvider().get("seat_selection.submit")
                                        )
                                )
                            ]),
                        ]
                        ),
                        appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null
                    )


                ])
            ])
        }
    }
}


export default SeatAssignmentAutoInfoPage;
